import React from "react";

export default function LastFooter() {
  return (
    <>
      <div style={{ background: "#fffcf8" }}>
        <div>
          <div style={{ boxShadow: "2px 0 4px 0 rgb(0 0 0 / 12%)" }}>
            <div className="style__f14___1FE-V">
              <h2>INDIA’S LARGEST HEALTHCARE PLATFORM</h2>
            </div>
            <div className="style__flex-box____V1Y1">
              <div>
                <div className="style__stats-num___3Ns_4">260m+</div>
                <div>Visitors</div>
              </div>
              <div>
                <div className="style__stats-num___3Ns_4">31m+</div>
                <div>Orders Delivered</div>
              </div>
              <div>
                <div className="style__stats-num___3Ns_4">1800+</div>
                <div>Cities</div>
              </div>
            </div>
            <div
              style={{
                height: "60px",
                display: "flex",
                background: "white",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: "1px",
                  borderTop: "1px solid #eaeaea",
                  width: "90%",
                  margin: "24px auto",
                  backgroundColor: "white",
                }}
              ></div>
            </div>

            <div className="style__down-bar___3FV6g">
              <div className="style__f20___2opYM">
                Get the link to download App
              </div>
              <div
                className="style__input-box___7akGm"
                style={{ marginTop: "20px" }}
              >
                <form>
                  <input
                    type="tel"
                    placeholder="Enter Phone Number"
                    autoComplete="off"
                    className="style__input-phone___2P9PU"
                  />
                  <button type="submit" className="style__next-button___3J4Nx">
                    Send Link
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="footerApp">
            <div className="style__main-link-bar___12igi">
              <div className="style__main-content___2sd49">Know Us</div>
              <ul>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> About Us</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Contact Us</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Press Coverage</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Careers</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Business Partnership</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Become a Health Partner</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="style__main-link-bar___12igi">
              <div className="style__main-content___2sd49">Our Policies</div>
              <ul>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span>Privacy Policy </span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Terms and Conditions</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Editorial Policy</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Return Policy</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span>IP Policy </span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Grievance Redressal Policy</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="style__main-link-bar___12igi">
              <div className="style__main-content___2sd49">Our Services</div>
              <ul>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Order Medicines</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Book Lab Tests</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span>Consult a Doctor </span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span>Ayurveda Articles </span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Hindi Articles</span>
                  </a>
                </li>
                <li>
                  <a style={{ textDecoration: "none" }} href="">
                    {" "}
                    <span> Care Plan</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="style__main-link-bar___12igi">
              <div className="style__main-content___2sd49">Connect</div>
              <ul>
                <li>
                  <span className="style__s-head___367TK">Social Links</span>
                </li>
                <li className="style__m-web___2xu0C">
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://www.facebook.com/1mgOfficial"
                    alt="Facebook"
                    rel="nofollow"
                    target="_blank"
                  >
                    <div className="facebook"></div>
                  </a>
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://twitter.com/1mgofficial"
                    alt="Twitter"
                    rel="nofollow"
                    target="_blank"
                  >
                    <div className="twitter"></div>
                  </a>
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://www.youtube.com/c/1mgofficial"
                    alt="You Tube"
                    rel="nofollow"
                    target="_blank"
                  >
                    <div className="youtube"> </div>
                  </a>
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://www.linkedin.com/company/1mg"
                    alt="Linkedin"
                    rel="nofollow"
                    target="_blank"
                  >
                    <div className="linkedin"> </div>
                  </a>
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://medium.com/1mgofficial"
                    alt="Medium Link"
                    rel="nofollow"
                    target="_blank"
                  >
                    <div className="medium"> </div>
                  </a>
                </li>
                <li>
                  <span className="style__s-head___367TK">
                    Want daily dose of health?
                  </span>
                </li>
                <li>
                  <button className="style__signup-btn___2h_dH ">
                    SIGN UP
                  </button>
                </li>
              </ul>
            </div>
            <div>
              <h5>Download App</h5>
              <ul className="ul_appstore">
                <li>
                  <div className="google_play"></div>
                </li>
                <li>
                  <div className="apple_store"></div>
                </li>
              </ul>
            </div>
          </div>
          <div className="style__auth-bar___bYPU8">
            <div className="style__auth-cont___2vf7G">
              <div className="reliable "></div>
              <div style={{ marginLeft: "25px" }}>
                <div>Reliable</div>
                <p style={{ fontSize: "12px", color: "#767676" }}>
                  All products displayed on Tata 1mg are procured from verified
                  and licensed pharmacies. All labs listed on the platform are
                  accredited
                </p>
              </div>
            </div>
            <div className="style__auth-cont___2vf7G">
              <div className="secure "></div>
              <div style={{ marginLeft: "25px" }}>
                <div>Secure</div>
                <p style={{ fontSize: "12px", color: "#767676" }}>
                  Tata 1mg uses Secure Sockets Layer (SSL) 128-bit encryption
                  and is Payment Card Industry Data Security Standard (PCI DSS)
                  compliant
                </p>
              </div>
            </div>
            <div className="style__auth-cont___2vf7G">
              <div className="affordable "></div>
              <div>
                <div>Affordable</div>
                <p style={{ fontSize: "12px", color: "#767676" }}>
                  Find affordable medicine substitutes, save up to 50% on health
                  products, up to 80% off on lab tests and free doctor
                  consultations.
                </p>
              </div>
            </div>
          </div>
          <div>
            <div className="style__trust-stamps____4BQl">
              <img src="https://static.legitscript.com/seals/729605.png" />
              <img src="https://res.cloudinary.com/du8msdgbj/image/upload/v1580717209/URS_ebgmxc.png" />
            </div>
            <div className="style__free-text3___3upNE">
              India's only LegitScript and ISO/ IEC 27001 certified online
              healthcare platform
            </div>
          </div>
          <div className="style__collapse___1sCdv">
            <h2 style={{ fontSize: "14px" }}>Know more about Tata 1mg</h2>
            <span>
              <img
                src="https://img.1mg.com/images/down-arrowRebrand.svg"
                alt="downArrow"
              />
            </span>
          </div>
          <div className="style__b-text___uV-wn">
            <div>
              <p className="style__copyright___qclAW">
                © 2022 Tata 1mg. All rights reserved. In compliance with Drugs
                and Cosmetics Act, 1940 and Drugs and Cosmetics Rules, 1945, we
                don't process requests for Schedule X and other habit forming
                drugs.
              </p>
            </div>
            <div className="payment"></div>
          </div>
        </div>
      </div>
    </>
  );
}
